import Swiper from "swiper";

export default () => {
    const testSwiper = document.querySelectorAll('.testimonial-slider');

    //if(window.innerWidth < 768) {
        // testSwiper.forEach((wrapper) => {
        //     wrapper.classList.remove('row');
        // })
        testSwiper.forEach((element) => {
            let params = JSON.parse(element.dataset.testSlider);
            console.log(params)
            new Swiper(element, params);
        });
    //}

    
}